import React from "react";
import Modal from "../ui/Modal";

const AboutPopup = ({ open, onClose, transformOrigin }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      className="py-10 md:py-14"
      childrenClassName="!max-h-[75vh]"
    >
      <div className="grid gap-5 md:grid-cols-[1.1fr_1.9fr]">
        <div className="flex flex-col items-center">
          <img
            src="/assets/img/woc_main.png"
            alt="The Web of Care"
            className="w-full"
          />
        </div>

        <div className="space-y-1.5 text-base leading-loose text-softBlack">
          <p className="">
            The Web of Care (Read Woke) project is an exploratory research into
            the care ecosystem. The aim of the project is to learn about the
            different components of this ecosystem and identify the various ways
            that these components are interwoven with each other, directly and
            indirectly. This will help advance how we, at Noora Health, develop
            a common understanding of this system, how we place ourselves within
            it, and how we can grow within it.
          </p>
          <div className="space-y-1.5">
            <p className="">
              This secondary research goes in-depth into various topics within
              the care ecosystem which were prioritized for the project. The
              topics are:
            </p>
            <ul className="ml-5 list-disc ">
              <li>The care economy</li>
              <li>Gender and caregiving</li>
              <li>Caregiving and mental health</li>
              <li>Climate change and caregiving</li>
              <li>Emerging trends in caregiving</li>
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AboutPopup;
